import { STAFF_DOOR } from './endpoints';

export interface AuthorizeParams {
  readonly clientId: string;
  readonly redirectUri: string;
  readonly state: string;
  readonly challenge: string;
  readonly scopes?: readonly string[];
  /** Cognito IdP name — Google or COGNITO. Omit to show Hosted UI chooser. */
  readonly identityProvider?: 'Google' | 'COGNITO';
}

/**
 * Builds the Cognito hosted-UI authorize URL. Does not navigate and does not contact AWS.
 */
export function buildAuthorizeUrl(params: AuthorizeParams): string {
  const url = new URL(STAFF_DOOR.authorizeEndpoint);
  const scopes = params.scopes ?? STAFF_DOOR.scopes;

  url.searchParams.set('response_type', 'code');
  url.searchParams.set('client_id', params.clientId);
  url.searchParams.set('redirect_uri', params.redirectUri);
  url.searchParams.set('scope', scopes.join(' '));
  url.searchParams.set('state', params.state);
  url.searchParams.set('code_challenge', params.challenge);
  url.searchParams.set('code_challenge_method', 'S256');
  if (params.identityProvider) {
    url.searchParams.set('identity_provider', params.identityProvider);
  }

  return url.toString();
}

/**
 * Allowlisted callback / logout root for the current origin.
 * Hash routes (`#/staff`) cannot be OAuth URIs — the fragment is not sent.
 */
export function previewRedirectUri(): string {
  return `${window.location.origin}/`;
}

export function staffLogoutUri(): string {
  return previewRedirectUri();
}

export { buildLogoutUrl, type LogoutParams } from './endpoints';
